import SimpleDictionaryFormConfig from '../../../components/common/SimpleDictionaryFormConfig';

const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'expertiseHeadOk',
      label: 'visualVerification.head',
      column: 1,
      defaultValue: 'true',
      type: 'radio',
    },
    {
      name: 'expertiseStemOk',
      label: 'visualVerification.stem',
      column: 1,
      defaultValue: 'true',

      type: 'radio',
    },
    {
      name: 'expertiseTipOk',
      label: 'visualVerification.tip',
      column: 1,
      defaultValue: 'true',

      type: 'radio',
    },
    {
      name: 'expertiseComment',
      label: 'general.comment',
      column: 1,
      type: 'textarea',
      maxLength: 1000
    },
    {
      name: 'expertiseProblemReason',
      label: 'general.problemReason',
      column: 1,
      type: 'dictionary',
      dictionary: 'problem-reason',
      dictionaryApi: 'expertise/problem-reason',
      creationForm: SimpleDictionaryFormConfig,
    },
  ],
};

export default fields;
